module.exports = __webpack_public_path__ + "img/1016.a87e28a5.png";